import { Button, ButtonTheme } from '@apply/components';
import { MouseEventHandler } from 'react';

interface EnabledRequestDrawButtonProps {
    handleClick: MouseEventHandler<Element> | undefined;
}
export const EnabledRequestDrawButton = ({ handleClick }: EnabledRequestDrawButtonProps) => {
    return (
        <Button
            id='secondaryButton'
            theme={ButtonTheme.Primary}
            width='160px'
            height='38px'
            handleClick={handleClick}
        >
            Draw
        </Button>
    );
};
